import React from 'react';
import PropTypes from 'prop-types';

import { themes } from '../../utils/globals';
import './BizButton.css';

const BizIconButton = (props) => (
  <div className={props.theme ? `biz-button biz-btn-theme-${props.theme}` : 'biz-button'} onClick={props.onClick}>
    <div className="icon">{props.children}</div>
    <p className="text">{props.title}</p>
  </div>
);

BizIconButton.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(themes),
  onClick: PropTypes.func,
};

BizIconButton.defaultProps = {
  theme: null,
  onClick: null,
};

export default BizIconButton;



// WEBPACK FOOTER //
// ./src/components/UI/BizIconButton.jsx